import { all } from 'redux-saga/effects';

import dadosPreCadastroFormSaveSaga from './dadosPreCadastroFormSave/saga';

export default all([dadosPreCadastroFormSaveSaga]);
